import React, { RefObject, useEffect, useRef } from 'react';
import CountryMap from 'components/Maps/CountryMap';
interface ILocationProps {
	setNextStepDisabled: (nextStepDisabled: boolean) => void;
	setGis: (gis: string) => void;
	address: { [key: string]: string };
	setAddress: (data: { [key: string]: string }) => void;
	location: { [key: string]: string };
	setLocation: (data: { [key: string]: string }) => void;
	setLocationInputs: (name: string, value: string) => void;
	mainContainerRef?: React.RefObject<HTMLDivElement>;
	height?: string;
}

const LocationTab = (props: ILocationProps) => {
	const { setGis, setAddress, setNextStepDisabled, address, location, setLocation, mainContainerRef } = props;
	const ref: RefObject<HTMLDivElement> = useRef(null);
	useEffect(() => {
		if (ref.current) ref.current.focus();
	}, []);
	useEffect(() => {
		setNextStepDisabled(true);
		setAddress({});
	}, [setNextStepDisabled]);

	useEffect(() => {
		setNextStepDisabled(Object.keys(address).length === 0);
	}, [address, setNextStepDisabled]);

	useEffect(() => {
		setLocation(
			(() => {
				const map = {
					networkType: 'networktype',
					latitude: 'LAT',
					longitude: 'LONG',
					wayNumber: 'WayNo',
					cabinet: 'cabinet',
					dp: 'DP',
					willayat: 'Wilayat',
					buildingNumber: 'BuildingNo',
					exe: 'exchange',
					governorate: 'Governorate',
					town: 'Town',
				};
				if (!!address) return Object.keys(map).reduce((acc, key) => ({ ...acc, [key]: address[map[key]] }), {});
				else return {};
			})()
		);
	}, [address, setLocation]);

	return (
		<div ref={ref}>
			<CountryMap
				setGis={setGis}
				setData={(data) => setAddress(data)}
				mainContainerRef={mainContainerRef}
				height={props.height}
			/>
			{/* <GridContainer>
				{inputs.map((input) => (
					<GridItem xs={12} sm={6} md={3} key={input}>
						<CustomInput
							formControlProps={{ fullWidth: true }}
							labelText={translate(`add.new.line.fixed.locationTab.${input}`)}
							inputProps={{
								value: location[input] || '',
								onChange: (event: any) => {
									props.setLocationInputs(input, event.target.value);
								},
							}}
						/>
					</GridItem>
				))}
			</GridContainer> */}
		</div>
	);
};

export default LocationTab;
